import { Controller, useForm } from 'react-hook-form';
// import { ReactComponent as Reliant } from 'assets/icons/reliant_icon.svg';
import { Button } from 'shared-components';
import { useAppDispatch } from 'hooks/reduxHooks';
import {
  setOnboarding,
  setToken,
  setIsGithubUser,
} from 'redux-setup/slices/userSlice';
import OTPInput from 'react-otp-input';
import { ReactComponent as BackArrow } from 'assets/icons/tabler_arrow-left.svg';
import { FC, useState } from 'react';
import {
  login,
  loginVerification,
  logOut,
  setTokensInStorage,
} from 'services/authService';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Path } from 'router/constant';
import { listOrganizationsForUser } from 'services/organizationService';
import 'components/loginVerification/style.scss';
import { setOrganization } from 'redux-setup/slices/organizationSlice';

interface ILoginForm {
  otpToken: string;
}

interface IProps {
  Email: string;
}

const LoginVerification: FC<IProps> = ({ Email }) => {
  const [loading, setLoading] = useState(false);
  const url = localStorage.getItem('invite_user_url');
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  // Determine if the current environment is development
  const isDevelopment = process.env.REACT_APP_ENV === 'development';

  // Set the default OTP token based on the environment
  const defaultOtpToken = isDevelopment ? '000000' : '';

  const { handleSubmit, control } = useForm<ILoginForm>({
    defaultValues: {
      otpToken: defaultOtpToken,
    },
  });

  const onSubmit = async (data: ILoginForm) => {
    setLoading(true);
    const response = await loginVerification({
      Email,
      Token: data.otpToken,
    });
    setLoading(false);
    if (response?.status !== 200) {
      toast.error('Failed To Login');
      return;
    }
    dispatch(setIsGithubUser(response.data.IsGithubUser));
    setTokensInStorage(response.data);

    const res = await listOrganizationsForUser();
    const err = res.check();

    if (err) {
      console.error('Error fetching organizations:', res);
      toast.error('Failed to fetch organizations');
      return;
    }

    const orgs = res.unwrap();
    if (orgs.Result) {
      const org = orgs.Result[0];
      dispatch(setOrganization({ id: String(org.ID), name: org.Name }));
      navigate(Path.DASHBOARD);
    } else {
      dispatch(setOnboarding(true));
      if (url) localStorage.setItem('navigate_url', url);
      navigate(Path.ON_BOARDING);
    }

    // TODO: We should fix this so that it is less fragile
    dispatch(setToken(response?.data?.RefreshToken));
  };

  const handleClickBack = () => {
    logOut();
  };

  const handleResend = async () => {
    if (loading) return;
    setLoading(true);
    const response = await login({ Email });
    setLoading(false);
    if (response.status === 200) toast.success('OTP Sent Successfully');
    else toast.error('Retry Failed');
  };

  return (
    <div className="login-verification-container">
      <div className="title-login-container">
        {/* <Reliant className="title-icon" /> */}
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="login-verification-form">
          <p className="form-text">Enter the 6-digit code sent to you at:</p>
          <p className="form-text">{Email}</p>
          <Controller
            name="otpToken"
            control={control}
            rules={{
              minLength: 6,
              required: true,
            }}
            render={({ field: { onChange, value } }) => {
              const handlechange = (e: string) => {
                onChange(e);
                // if the user enter all the otp number it will auto trigger the submit
                if (e.length === 6) {
                  handleSubmit(data => onSubmit(data))();
                }
              };
              return (
                <OTPInput
                  onChange={handlechange}
                  value={value}
                  numInputs={6}
                  shouldAutoFocus={true}
                  containerStyle="otp-container"
                  inputStyle="otp-input-styles"
                  renderInput={props => (
                    <input
                      {...props}
                      disabled={loading || isDevelopment} // Disable input in development to prevent changes
                    />
                  )}
                />
              );
            }}
          />
          <p className="verification-tip">
            Tip: Make sure to check your inbox and spam folders
          </p>
          <Button
            disabled={loading}
            loading={loading}
            className="login-verify-submit"
            variant="reliant"
            type="submit"
            label="VERIFY"
          />
          <div className="login-verify-footer">
            <div className="back-to-login" onClick={handleClickBack}>
              <BackArrow />
              <p>Back</p>
            </div>
            <div className="resend-otp">
              Didnt receive a code?&nbsp;
              <span className="resend-otp-link" onClick={handleResend}>
                Click here to resend
              </span>
            </div>
          </div>
        </div>
        <div className="animated-circle right-circle"></div>
        <div className="animated-circle top-circle"></div>
        <div className="animated-circle bottom-circle"></div>
      </form>
    </div>
  );
};

export default LoginVerification;
